/* Keep cart payment estimates and accessible item counts in sync after app rerenders. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root.document) api.start(root);
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';
  function parseBRL(text) {
    var matches = Array.from(String(text || '').matchAll(/R\$\s*([\d.,]+)/g));
    if (!matches.length) return null;
    var value = Number(matches[matches.length - 1][1].replace(/\./g, '').replace(',', '.'));
    return Number.isFinite(value) && value >= 0 ? Math.round(value * 100) : null;
  }
  function estimate(total, discount, installments, minimum) {
    var count = Math.max(1, Math.min(installments, Math.floor(total / minimum)));
    return { pix: Math.round(total * (1 - discount)), count: count, installment: Math.round(total / count) };
  }
  function money(cents) {
    return 'R$ ' + (cents / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function start(root) {
    if (root.theoricCartDisplaySync) return;
    root.theoricCartDisplaySync = true;
    var doc = root.document;
    var queued = false;
    function setText(element, value) {
      if (element && element.textContent.replace(/\s/g, ' ').trim() !== String(value).replace(/\s/g, ' ').trim()) element.textContent = value;
    }
    function configuredNumber(source, name, fallback, min, max) {
      var match = source.match(new RegExp('\\b' + name + '\\s*=\\s*(\\d+(?:\\.\\d+)?)\\s*;'));
      var number = match ? Number(match[1]) : fallback;
      return Number.isFinite(number) && number >= min && number <= max ? number : fallback;
    }
    function sync() {
      queued = false;
      var bubble = doc.querySelector('#cart-icon-bubble .cart-count-bubble');
      if (bubble) {
        var visible = bubble.querySelector('[aria-hidden="true"]');
        var quantity = visible && visible.textContent.trim();
        if (quantity && /^\d+\+?$/.test(quantity)) setText(bubble.querySelector('.visually-hidden'), quantity + (quantity === '1' ? ' item' : ' itens'));
      }
      var footer = doc.querySelector('.kaching-cart__footer');
      if (!footer) return;
      var subtotal = footer.querySelector('.kaching-cart__subtotal');
      var total = parseBRL(subtotal && subtotal.textContent);
      if (total === null) return;
      var settings = root.__kachingCartProps && root.__kachingCartProps.cartSettings;
      var source = String(settings && settings.general && settings.general.customJs || '');
      var values = estimate(total,
        configuredNumber(source, 'PIX_DISCOUNT', .05, 0, 1),
        Math.floor(configuredNumber(source, 'INSTALLMENTS', 6, 1, 24)),
        configuredNumber(source, 'MIN_INSTALLMENT', 1, 1, 1000000));
      setText(footer.querySelector('[data-lcw-pix-value]'), money(values.pix));
      setText(footer.querySelector('[data-lcw-installment-value]'), money(values.installment));
      setText(footer.querySelector('[data-lcw-installment-count]'), values.count);
    }
    function queue() {
      if (!queued) { queued = true; root.requestAnimationFrame(sync); }
    }
    var selector = '.kaching-cart, #cart-icon-bubble';
    function relevant(node) {
      var element = node.nodeType === 1 ? node : node.parentElement;
      return element && (element.closest(selector) || element.querySelector(selector));
    }
    function initialize() {
      sync();
      doc.addEventListener('click', function (event) {
        var link = event.target.closest && event.target.closest('a[href]');
        if (!link || link.id === 'cart-icon-bubble' || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
        var url = new URL(link.href, root.location.href);
        if (url.origin !== root.location.origin || !/\/cart\/?$/.test(url.pathname)) return;
        if (root.kachingCartApi && typeof root.kachingCartApi.openCart === 'function') {
          event.preventDefault();
          root.kachingCartApi.openCart();
        }
      });
      var openIntent = false;
      try { openIntent = root.sessionStorage.getItem('theoric-cart-open-intent') === '1'; } catch (_) {}
      if (openIntent && !/\/cart\/?$/.test(root.location.pathname)) {
        var attempts = 0;
        (function openRequestedCart() {
          if (root.kachingCartApi && typeof root.kachingCartApi.openCart === 'function') {
            try { root.sessionStorage.removeItem('theoric-cart-open-intent'); } catch (_) {}
            root.kachingCartApi.openCart();
          } else if (++attempts < 50) root.setTimeout(openRequestedCart, 200);
          else { try { root.sessionStorage.removeItem('theoric-cart-open-intent'); } catch (_) {} }
        })();
      }
      new root.MutationObserver(function (records) {
        if (records.some(function (record) { return relevant(record.target) || Array.from(record.addedNodes).some(relevant); })) queue();
      }).observe(doc.body, { childList: true, subtree: true, characterData: true });
      ['cart:updated', 'cart:refresh', 'cart:change', 'shopify:section:load'].forEach(function (event) { doc.addEventListener(event, queue); });
    }
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
  }
  return { parseBRL: parseBRL, estimate: estimate, start: start };
});
